var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import LayeredDialog from "../components/dialog/layereddialog.vue";
import ModalBase from "../components/modalbase.vue";
import { isTypeOrUndefined, } from "./utilities/aux";
import { isTwoDimInput, } from "./utilities/wsi4_typeguards";
let ErrorDialog = class ErrorDialog extends Vue {
    constructor() {
        super(...arguments);
        this.openLayeredIndex = -1;
        this.twoDimInputs = [];
    }
    close() { }
    openLayeredInfo(index) { this.openLayeredIndex = index; }
    translate(t) {
        if (t === "InvalidInput") {
            return this.i18n.t("fileInvalid")
                .toString();
        }
        else {
            if (t !== "InvalidLayered") {
                throw Error("Wrong tag.");
            }
            return this.i18n.t("dxfInvalid")
                .toString();
        }
    }
    ignoreLayered() {
        this.handleTwoDimInput(undefined);
    }
    handleTwoDimInput(result) {
        if (!isTypeOrUndefined(result, isTwoDimInput)) {
            throw Error("Wrong type.");
        }
        const tmp = this.twoDimInputs;
        tmp[this.openLayeredIndex] = result;
        this.twoDimInputs = tmp;
        this.openLayeredIndex = -1;
    }
    handleClosing() {
        const twoDimInputs = this.twoDimInputs.filter(h => h !== undefined)
            .map((h) => {
            if (!isTwoDimInput(h)) {
                throw Error("Wrong type.");
            }
            return h;
        });
        if (twoDimInputs.length !== 0) {
            if (!this.networkBroker.queueAddLayeredsRequest(twoDimInputs)) {
                throw Error("Error queueing request");
            }
            if (!this.networkBroker.queueGraphRequest()) {
                throw Error("Error queueing request");
            }
            this.networkBroker.process();
        }
        this.close();
    }
    handleRequest() {
        this.close();
        this.networkBroker.request();
    }
    changedLayer(index) {
        return this.twoDimInputs[index] !== undefined;
    }
    tagText(index) {
        if (this.scriptError.tag === "ErrorMessage") {
            return "";
        }
        let suffix = "";
        if (this.scriptError.errors[index].tag === "InvalidLayered") {
            if (this.twoDimInputs[index] !== undefined) {
                return this.i18n.t("layersSelected");
            }
            if (this.twoDimInputs[index] === undefined) {
                suffix = " (" + this.i18n.t("fileIgnored") + ")";
            }
        }
        return this.translate(this.scriptError.errors[index].tag) + suffix;
    }
    get isErrorMessage() {
        return this.scriptError.tag === "ErrorMessage";
    }
    get header() {
        if (this.scriptError.tag === "ErrorMessage") {
            return this.i18n.t("errorHeader")
                .toString();
        }
        else {
            return this.i18n.t("fileError")
                .toString();
        }
    }
    get infoText() {
        if (this.scriptError.tag === "ErrorMessage") {
            return this.scriptError.message.includes("script") ? this.i18n.t("scriptError") : this.i18n.t("unknownError");
        }
        return "";
    }
    get buttonText() {
        if (this.scriptError.tag === "ErrorMessage") {
            return "Ok";
        }
        return this.scriptError.errors.some(e => e.tag === "InvalidLayered") ? this.i18n.t("submit") : "Ok";
    }
    mounted() {
        if (this.scriptError.tag === "ImportErrors") {
            this.twoDimInputs = this.scriptError.errors.map(_s => undefined);
        }
    }
};
__decorate([
    Prop({ required: true })
], ErrorDialog.prototype, "scriptError", void 0);
__decorate([
    Inject()
], ErrorDialog.prototype, "i18n", void 0);
__decorate([
    Inject()
], ErrorDialog.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], ErrorDialog.prototype, "close", null);
ErrorDialog = __decorate([
    Component({
        components: {
            "modal-base": ModalBase,
            LayeredDialog,
        },
        name: "ErrorDialog",
    })
], ErrorDialog);
export default ErrorDialog;
